import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { type FC } from 'react';
import { IntlProvider } from 'dibs-react-intl';
import { type Locale } from 'dibs-intl/exports/locales';
import {
    type DEVICE_TYPES,
    DESKTOP,
    MOBILE,
    TABLET,
} from 'dibs-buyer-layout/exports/deviceTypeEnums';
import { useLazyLoadQuery } from 'react-relay';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout';
import { NftPdpRespLayout } from '../nftPdp/NftPdpRespLayout';
import { ServerVarsContextProvider } from '../utils/ServerVarsContext';
import {
    nftPdpRespRootQuery,
    type nftPdpRespRootQueryType,
    type nftPdpRespRootQuery$variables,
} from '../nftPdp/nftPdpRespRootQuery';

type Props = {
    locale: Locale;
    deviceType: DEVICE_TYPES;
    store: Store;
    variables: nftPdpRespRootQuery$variables;
};

export const NftPdpWrapper: FC<Props> = ({ locale, deviceType, store, variables }) => {
    const data = useLazyLoadQuery<nftPdpRespRootQueryType>(nftPdpRespRootQuery, variables, {
        fetchPolicy: 'store-only',
    });
    return (
        <IntlProvider locale={locale} disableTranslations>
            <ServerVarsContextProvider
                isMobile={deviceType === MOBILE}
                isTablet={deviceType === TABLET}
                isDesktop={deviceType === DESKTOP}
            >
                <Provider store={store}>
                    <DibsWeb3ReactProvider>
                        <NftHeaderLayout viewer={data.viewer} serverDeviceType={deviceType}>
                            <NftPdpRespLayout viewer={data.viewer} />
                        </NftHeaderLayout>
                    </DibsWeb3ReactProvider>
                </Provider>
            </ServerVarsContextProvider>
        </IntlProvider>
    );
};
